/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface QuoteTestScenarioMetadata
 */
export interface QuoteTestScenarioMetadata {
  /**
   *
   * @type {Array<string>}
   * @memberof QuoteTestScenarioMetadata
   */
  linearIds: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof QuoteTestScenarioMetadata
   */
  shipmentIds: Array<string>;
}

/**
 * Check if a given object implements the QuoteTestScenarioMetadata interface.
 */
export function instanceOfQuoteTestScenarioMetadata(
  value: object,
): value is QuoteTestScenarioMetadata {
  if (!("linearIds" in value) || value["linearIds"] === undefined) return false;
  if (!("shipmentIds" in value) || value["shipmentIds"] === undefined)
    return false;
  return true;
}

export function QuoteTestScenarioMetadataFromJSON(
  json: any,
): QuoteTestScenarioMetadata {
  return QuoteTestScenarioMetadataFromJSONTyped(json, false);
}

export function QuoteTestScenarioMetadataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuoteTestScenarioMetadata {
  if (json == null) {
    return json;
  }
  return {
    linearIds: json["linearIds"],
    shipmentIds: json["shipmentIds"],
  };
}

export function QuoteTestScenarioMetadataToJSON(
  json: any,
): QuoteTestScenarioMetadata {
  return QuoteTestScenarioMetadataToJSONTyped(json, false);
}

export function QuoteTestScenarioMetadataToJSONTyped(
  value?: QuoteTestScenarioMetadata | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    linearIds: value["linearIds"],
    shipmentIds: value["shipmentIds"],
  };
}
